import * as React from 'react';

import LoggedOutConsumerDesktopMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/desktop/LoggedOutConsumerDesktopMainNav';
import LoggedOutConsumerMobileMainNav from 'bundles/composable-page-header-consumer/main-nav-modules/mobile/LoggedOutConsumerMobileMainNav';
import GlobalPageHeaderContainer from 'bundles/composable-page-header/components/GlobalPageHeaderContainer';
import DefaultMetaNavigation from 'bundles/composable-page-header/components/meta-nav/DefaultMetaNavigation';
import { DEFAULT_META_NAV_HEIGHT } from 'bundles/composable-page-header/constants';
import GlobalPageHeaderStateProvider from 'bundles/composable-page-header/providers/GlobalPageHeaderStateProvider';

const ConsumerLoggedOutHomePageHeader = () => {
  return (
    <span data-catchpoint="page-header-controls" data-testid="logged-out-desktop-header">
      <GlobalPageHeaderContainer
        desktopMainNav={<LoggedOutConsumerDesktopMainNav />}
        mobileMainNav={<LoggedOutConsumerMobileMainNav />}
        metaNav={<DefaultMetaNavigation />}
        scrollMovementOffset={{
          desktop: DEFAULT_META_NAV_HEIGHT,
          mobile: 0,
        }}
      />
    </span>
  );
};

const ConsumerLoggedOutHomePageHeaderWithProvider = () => {
  return (
    <GlobalPageHeaderStateProvider additionalDefaultPageHeaderHeight={DEFAULT_META_NAV_HEIGHT}>
      <ConsumerLoggedOutHomePageHeader />
    </GlobalPageHeaderStateProvider>
  );
};

export default ConsumerLoggedOutHomePageHeaderWithProvider;
